// extracted by mini-css-extract-plugin
module.exports = {"toggles":"toggles__13vF3"};